import React, { useContext } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from '../../src/App';
// import reportWebVitals from '../../reportWebVitals';
import { AuthProvider } from '../../src/authContext';
import { BrowserRouter } from 'react-router-dom';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
      <App/>
    </BrowserRouter>

    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
